export default "__VITE_PUBLIC_ASSET__e1d58aad__"